import { FunctionComponent } from "react";
import { useState } from 'react';
import Menu from './menu';
const NAV: FunctionComponent = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };
  return (
    
    <div className="rounded-981xl nav-b  flex flex-row items-center w-[90%] justify-between px-[3rem] py-[1rem] text-center text-[1.38rem] text-white font-anek-devanagari">
      <img
        className="w-[2.5rem] relative h-[2.65rem] object-cover"
        alt=""
        src="/image-203@2x.png"
      />
      <div className="flex-1 flex flex-row items-center justify-end gap-[4.06rem] max-md:gap-[1rem]">
        <button className='bg-transparent cursor-pointer' onClick={handleMenuToggle}>
          <img className="w-[35px]" src="https://media.discordapp.net/attachments/873160190063673354/1199273740068999218/image.png?ex=65c1f1b5&is=65af7cb5&hm=468bba4dbb18f2f78bc3dc39df6b01b42a0816b899ab43062952788ed841902f&=&format=webp&quality=lossless&width=271&height=142" alt="" />
          </button>
        <Menu isOpen={isMenuOpen} onClose={handleMenuClose} />
      </div>
    </div>
  );
};

export default NAV;
